import React from "react";
import { useNavigate, Link } from "react-router-dom";
import { Home, FileText, ArrowRight } from "lucide-react";
import QuoteRequestGuard from "../components/QuoteRequestGuard";

const HomePage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <QuoteRequestGuard>
      <div className="min-h-screen bg-gradient-to-b from-white to-gray-50">
        <div className="container mx-auto px-4 py-16">
          <div className="max-w-3xl mx-auto text-center">
            <h1 className="text-4xl font-bold text-gray-900 mb-6">
              Let's Get Started
            </h1>
            <p className="text-xl text-gray-600 mb-12">
              We'll help you make the best decision for your mortgage
            </p>

            <div className="grid md:grid-cols-2 gap-8 mb-8">
              <button
                onClick={() => navigate("/check-my-rate")}
                className="group p-8 bg-white rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100"
              >
                <div className="flex flex-col items-center">
                  <div className="w-16 h-16 bg-blue-50 rounded-full flex items-center justify-center mb-4 group-hover:bg-blue-100 transition-colors">
                    <FileText className="w-8 h-8 text-primary" />
                  </div>
                  <h2 className="text-xl font-semibold text-gray-900 mb-2">
                    I already have a rate quote
                  </h2>
                  <p className="text-gray-600">
                    Get an in-depth analysis of your current quote from your
                    broker or lender
                  </p>
                </div>
              </button>

              <button
                onClick={() => navigate("/loan-information")}
                className="group p-8 bg-white rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100"
              >
                <div className="flex flex-col items-center">
                  <div className="w-16 h-16 bg-green-50 rounded-full flex items-center justify-center mb-4 group-hover:bg-green-100 transition-colors">
                    <Home className="w-8 h-8 text-green-600" />
                  </div>
                  <h2 className="text-xl font-semibold text-gray-900 mb-2">
                    I'm shopping for a mortgage
                  </h2>
                  <p className="text-gray-600">
                    Get personalized mortgage quotes and analysis
                  </p>
                </div>
              </button>
            </div>

            <Link
              to="/example-results"
              className="inline-flex items-center text-primary hover:text-primary-dark text-sm transition-colors mb-8"
            >
              <span>What will this get me?</span>
              <ArrowRight className="w-4 h-4 ml-1" />
            </Link>

            <div className="flex justify-start">
              <button onClick={() => navigate(-1)} className="btn-secondary">
                Back
              </button>
            </div>
          </div>
        </div>
      </div>
    </QuoteRequestGuard>
  );
};

export default HomePage;
